import { AvField } from "availity-reactstrap-validation"
import { Alert, Row, Col } from "reactstrap"
import CountriesStates from "./CountriesStates"
import WasteIdentification from "./WasteIdentification"

import Licensing from "services/Licensing.service"
import { useEffect, useState } from "react"

const user = JSON.parse(localStorage.getItem("authUser"))
let licensingService = new Licensing(user)

const BaselForm = props => {
  const [purposes, setpurposes] = useState()
  const [concernings, setconcernings] = useState()
  const [measures, setmeasures] = useState()
  const [editRecoveryFacility, seteditRecoveryFacility] = useState()
  const [editSpecialHandling, seteditSpecialHandling] = useState()

  useEffect(() => {
    fetchBaselPurposes()
    fetchNotificationConcernings()
    fetchQuantityMeasures()

    console.log("---------", props.appDetails)
    if (props.editMode) {
      if (props.appDetails.basel_convention.is_recovery_facility) {
        seteditRecoveryFacility("yes")
      } else {
        seteditRecoveryFacility("no")
      }

      if (props.appDetails.basel_convention.special_handling_requirements) {
        seteditSpecialHandling("yes")
      } else {
        seteditSpecialHandling("no")
      }
    }
  }, [])

  const fetchBaselPurposes = () => {
    licensingService.getBaselPurposes().then(response => {
      if (response.status) {
        const pps = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setpurposes(pps)
      }
    })
  }
  const fetchNotificationConcernings = () => {
    licensingService.getNotificationConcerning().then(response => {
      //console.log(response)
      if (response.status) {
        const concs = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setconcernings(concs)
      }
    })
  }

  const fetchQuantityMeasures = () => {
    licensingService.getQuantityMeasures().then(response => {
      console.log(response)
      if (response.status) {
        const meas = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setmeasures(meas)
      }
    })
  }
  return (
    <>
      <Row>
        <Col md={12}>
          <Row className="mb-3">
            <div className="">
              <AvField
                type="text"
                name="registration_number"
                label="Registration Number"
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.registration_number
                    : ""
                }
              />
            </div>
          </Row>
        </Col>
      </Row>
      <Row>
        <AvField
          type="text"
          name="chemicals_name"
          label="Enter chemical Name"
          required
          value={
            props.editMode
              ? props.appDetails.basel_convention.chemicals_name
              : ""
          }
        />
      </Row>
      <br></br>

      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Notification concerning
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="select"
                name="notification_concern_id"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.notification_concern_id
                    : ""
                }
              >
                <option value="">--select--</option>
                {concernings}
              </AvField>
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Purpose
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="select"
                name="basel_purpose_id"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.basel_purpose_id
                    : ""
                }
              >
                <option value="">--select--</option>
                {purposes}
              </AvField>
            </div>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Pre-consented recovery facility
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="select"
                name="is_recovery_facility"
                label=""
                required
                value={editRecoveryFacility}
              >
                <option value="">--select--</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </AvField>
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Total intended number of shipments
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="number"
                name="number_of_shipments"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.number_of_shipments
                    : ""
                }
              />
            </div>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Total intended quantity
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="number"
                name="quantity"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.quantity
                    : ""
                }
              />
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Quantity measure
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="select"
                name="quantity_measure_id"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.quantity_measure_id
                    : ""
                }
              >
                <option value="">--select--</option>
                {measures}
              </AvField>
            </div>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              First Departure
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="date"
                name="first_departure"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.first_departure
                    : ""
                }
              />
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Last Departure
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="date"
                name="last_departure"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.last_departure
                    : ""
                }
              />
            </div>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Packaging Type (s)
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="text"
                name="packaging_types"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.packaging_types
                    : ""
                }
              />
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Special handling requirements
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="select"
                name="special_handling_requirements"
                label=""
                required
                value={editSpecialHandling}
              >
                <option value="">--select--</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </AvField>
            </div>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Designation and composition of the waste
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="textarea"
                name="composition_of_waste"
                label=""
                placeholder="Enter designation and composition of waste here!"
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.composition_of_waste
                    : ""
                }
              />
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Physical characteristics
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="textarea"
                name="physical_characteristics"
                label=""
                placeholder="Enter physical characteristics here!"
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.physical_characteristics
                    : ""
                }
              />
            </div>
          </Row>
        </Col>
      </Row>

      <hr></hr>
      <h5>Intended Carriers</h5>
      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Registration Number
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="text"
                name="intended_carrier_reg_number"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention
                        .intended_carrier_reg_number
                    : ""
                }
              />
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Name
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="text"
                name="carrier_name"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.carrier_name
                    : ""
                }
              />
            </div>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Address
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="text"
                name="carrier_address"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.carrier_address
                    : ""
                }
              />
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Contact Person
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="text"
                name="contact_person"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.contact_person
                    : ""
                }
              />
            </div>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Email
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="text"
                name="contact_person_email"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.contact_person_email
                    : ""
                }
              />
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Means of Transport
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="text"
                name="means_of_transport"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.means_of_transport
                    : ""
                }
              />
            </div>
          </Row>
        </Col>
      </Row>

      <hr></hr>
      <h5>Disposal/Recovery Operation(s)</h5>
      <Row>
        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              D-code / R-code
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="text"
                name="discovery_code"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.discovery_code
                    : ""
                }
              />
            </div>
          </Row>
        </Col>

        <Col md={6}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Technology employed
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="text"
                name="technology_employed"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.technology_employed
                    : ""
                }
              />
            </div>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Row className="mb-3">
            <label htmlFor="" className="col-lg-3 col-form-label">
              Reason for Export
              <span className="text-danger">*</span>
            </label>
            <div className="col-lg-9">
              <AvField
                type="text"
                name="reason"
                label=""
                required
                value={
                  props.editMode
                    ? props.appDetails.basel_convention.reason
                    : ""
                }
              />
            </div>
          </Row>
        </Col>
      </Row>

      <hr></hr>
      <h5>Waste identification (Fill in relevant codes where applicable)</h5>
      <Row>
        <Col lg={12}>
          <WasteIdentification appId={props.editMode? props.appDetails.id : ""} editMode={props.editMode} label="Basel Annex VIII or IX" />
        </Col>
      </Row>

      <hr></hr>
      <h5>Countries/States concerned</h5>
      <CountriesStates appId={props.editMode? props.appDetails.id : ""} editMode={props.editMode} />
    </>
  )
}

export default BaselForm
